<template>
  <b-card-body>
    <template>
      <b-card-title>Tiktok Channel</b-card-title>
      <b-card-sub-title>Managing direct messages for a Business Account is a key feature of the Business Messaging API, enabling businesses to interact effectively with TikTok users.</b-card-sub-title>
        <el-divider/>
      <b-card-sub-title class="font-weight-bold">Before you start, you'll need:</b-card-sub-title>
      <ol>
        <!-- <li>An <a href="https://help.instagram.com/502981923235522" target="_blank">Tiktok Account</a> or <a href ="https://help.instagram.com/1158274571010880">Tiktok Business Account</a></li> -->
        <li>Login Tiktok Account</li>
      </ol>
      <el-button :loading="loading.embed_signup" @click="launchTiktokSignup()" style="background-color: #1877f2; border: 0; border-radius: 4px; color: #fff; cursor: pointer; font-size: 16px; font-weight: bold; height: 40px; padding: 0 24px;">Connect with Tiktok</el-button>
    </template>
  </b-card-body>
</template>
<script>
// import CountryFlag from 'vue-country-flag';
import channelsAPI from '../../../api/channels';
import popupErrorMessages from '../../../library/popup-error-messages';

export default {
  components: {
    // CountryFlag,
  },
  name: 'AddTiktokChannel',
  data() {
    return {
      provider: '',
      hasRegisteredAccount: null,
      configuration: {
        username: 'admin',
        password: '',
        base_url: '',
        token: '',
        business_id: '',
        phone_number_id: '',
      },
      loading: {
        embed_signup: false,
      },
      phone_number_list: [],
    };
  },
  mounted() {
    // const params = new URLSearchParams(url);
    // const params = this.$route.params;
    // const code = params.get('code');
    // const state = params.get('state');
    // const error = params.get('error');
    console.log(this.$route.query);
    if (this.$route.query.code && this.$route.query.scopes) {
      this.responseOauth();
    }
  },
  methods: {
    createChannel() {
      this.$emit('createChannel', this.configuration, this.provider);
    },
    /* eslint-disable no-undef */
    async launchTiktokSignup() {
      try {
        this.loading.embed_signup = true;
        const client_key = '7506700603886206977';
        const authUrl = `https://www.tiktok.com/v2/auth/authorize?client_key=${client_key}&scope=user.info.basic%2Cuser.info.username%2Cuser.info.stats%2Cuser.info.profile%2Cuser.account.type%2Cuser.insights%2Cvideo.list%2Cvideo.insights%2Ccomment.list%2Ccomment.list.manage%2Cvideo.publish%2Cvideo.upload%2Cbiz.spark.auth%2Cdiscovery.search.words%2Cmessage.list.read%2Cmessage.list.send%2Cmessage.list.manage&response_type=code&redirect_uri=https%3A%2F%2Fdemo.dashboard.makna.ai%2Fredirect%2Flinkage-tiktok`;
        // const windowFeatures = 'width=600,height=650,top=70,left=500,toolbar=no,location=no,status=no,menubar=no,scrollbars=yes';
        // this.popup = window.open(authUrl, 'Tiktok Authorization', windowFeatures);
        // window.addEventListener('message', this.handleMessage, true);
        window.location.href = authUrl;
        // this.configuration = response1.data;
        // this.provider = 'instagram_direct';
        // this.createChannel();
      } catch (error) {
        console.log(error);
        this.loading.embed_signup = false;
      }
    },
    handleMessage(event) {
      console.log(event);
      console.log(event.data);
      console.log(event.origin);
      console.log(window.location.origin);
      console.log(window.location.href);
      console.log('======');
      if (event.origin !== window.location.origin || !event.data || !event.data.type || event.data.type !== 'authResult') {
        return;
      }
      this.loading.embed_signup = false;
      // Clean up after receiving the message.
      // window.removeEventListener('message', this.handleMessage, false);
      // if (this.popup) {
      //   this.popup.close();
      // }
      // window.location.href = window.location.origin;
    },
    responseOauth() {
      this.loading.embed_response = true;
      const auth_code = this.$route.query.code;
      // const scopes = this.$route.query.scopes;
      channelsAPI.initLinkAgeTiktok({
        code: auth_code,
        scopes: this.$route.query.scopes,
      }).then(async (response) => {
        await popupErrorMessages(response);
        this.configuration = response.data;
        this.provider = 'tiktok_messaging';
        this.createChannel();
      }).catch(async (err) => {
        await popupErrorMessages(err);
        this.loading.embed_response = false;
      });
    },
  },
};
</script>
